/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Link } from 'react-router-dom';
import { saveAs } from 'file-saver'; 
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

export default function data() {
  function formatNumber(n) {
    if (!n) return '0.00';
    let parts = n.toString().split(".");

    // Apply comma as thousands separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Ensure three decimal places
    if (parts[1]) {
      if (parts[1].length === 1) {
        parts[1] += "0"; // Add two zeros if there's only one digit
      } else if (parts[1].length > 3) {
        parts[1] = parts[1].substr(0, 2); // Truncate to three digits if longer
      }
      // No else needed for exactly three digits
    } else {
      parts[1] = "00"; // Add ".000" if there's no decimal part
    }

    return parts.join(".");
  }
  function monthConverter(inputDate) {
    const parts = inputDate.split("-");
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[1], 10);

    // Create a JavaScript Date object
    const date = new Date(year, month - 1, 1); // Note: Months are 0-based, so we subtract 1

    // Format the date as "MMM-yyyy" (e.g., "Oct-2023")
    const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
    return formattedDate;
  }
  function readableFormatDate(dateStr){
    const dateObj = new Date(dateStr);

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes}:${seconds} ${period}`;
    return formattedDate;
  }

  function readableFormatDate2(dateStr) {
    const dateObj = new Date(dateStr);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-indexed
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    // const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }


  return {
    auditTrailcolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "Merchant name / Reference Company Name / Name", accessor: "userName", width: "10%", align: "left" },
      { Header: "module", accessor: "module", width: "10%", align: "left" },
      { Header: "Sub Module", accessor: "subModule", width: "10%", align: "left" },
      // { Header: "Activity Time", accessor: row => readableFormatDate(row.actTime), width: "10%", align: "left" },
      { Header: "Request Ip", accessor: "reqIp", width: "10%", align: "left" },
      { Header: "User Level", accessor: "userLevel", width: "10%", align: "left" },
      {
        Header: "Summary",
        accessor: "summary",
        width: "10%",
        align: "left",
        Cell: ({ row }) => (
          <button
            onClick={() => {
              const blob = new Blob([row.original.summary], { type: "text/plain;charset=utf-8" });
              const datatime = new Date().toISOString().replace(/[-:]/g, '').replace('T', '_').replace(/\..+/, '');
              saveAs(blob, `Summary_${row.original.userId}_${datatime}.txt`);
              
            }}
          >
            Download
          </button>
        ),
      },
    ],
    transactionSummarycolumns: [
      { Header: "Merchant Id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Date", accessor: "transaction_dt", width: "10%", align: "left" },
      { Header: "Card Transaction", accessor: "pos_transactions", width: "10%", align: "left" },
      { Header: "Card Amount", accessor: row => formatNumber(row.pos_amount), width: "10%", align: "left" },
      { Header: "Cash Transaction", accessor: "cash_transactions", width: "10%", align: "left" },
      { Header: "Cash Amount", accessor: row => formatNumber(row.cash_amount), width: "10%", align: "left" },
      { Header: "Total Transaction", accessor: "total_transactions", width: "10%", align: "left" },
      { Header: "Total Amount", accessor: row => formatNumber(row.total_amount), width: "10%", align: "left" },
    ],
    transactionReportcolumns: [
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Terminal Id", accessor: "terminalId", width: "10%", align: "left" },
      { Header: "rrn", accessor: "rrn", width: "10%", align: "left" },
      { Header: "stan", accessor: "stan", width: "10%", align: "left" },
      { Header: "Transaction Amount", accessor: row => formatNumber(row.transactionAmount), width: "10%", align: "left" },
      { Header: "Type", accessor: "type", width: "10%", align: "left" },
      { Header: "Status", accessor: "status", width: "10%", align: "left" },
      { Header: "Transaction Date", accessor: "transactionDate", width: "10%", align: "left" },
    ],
    userTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      { Header: "User Level", accessor: "role", width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    merchantTablecolumns: [
      { Header: "", accessor: "view", width: "2%", align: "left", isSorted: false },
      { Header: "Merchant Id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Company Name", accessor: "companyName", width: "10%", align: "left" },
      // { Header: "Owner Name", accessor: "ownerName", width: "10%", align: "left" },
      // { Header: "Account No", accessor: "accountNo", width: "10%", align: "left" },
      { Header: "Group Id", accessor: "referenceId", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
      { Header: "Settlement Allowed", accessor: "settlementAllowed", width: "10%", align: "left" },
      { Header: "IS LCR Enabled", accessor: "lcrenbale", width: "10%", align: "left" },
    ],
    merchantGroupTablecolumns: [
      { Header: "Reference compnay code", accessor: "referenceId", width: "10%", align: "left" },
      { Header: "Refrerence company Name", accessor: "referenceCompanyName", width: "10%", align: "left" },
      { Header: "Owner name", accessor: "ownerName", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
    ],
    terminalTablecolumns: [
      { Header: "merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "Terminal id / Username", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Mapping", accessor: row => {
        if (row.device	 != null){
          return (
            <Chip
              icon={<Icon>check_circle</Icon>}
              label="Mapped"
              color="success"
              size="small"
              variant="outlined"
            />
          );
        } else {
          return <></>;
        }
      }, width: "10%", align: "left" },
      { Header: "Terminal Serial", accessor: row => {
        if (row.device	 != null){
          return row.device.serialNo;
        } else {
          return <></>;
        }
      }, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    allTerminalTablecolumns: [
      { Header: "Merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "Terminal id", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "10%", align: "left" },
      { Header: "Mapping", accessor: row => {
        if (row.device	 != null){
          return (
            <Chip
              icon={<Icon>check_circle</Icon>}
              label="Mapped"
              color="success"
              size="small"
              variant="outlined"
            />
          );
        } else {
          return <></>;
        }
      }, width: "10%", align: "left" },
      { Header: "Terminal Serial", accessor: row => {
        if (row.device	 != null){
          return row.device.serialNo;
        } else {
          return <></>;
        }
      }, width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Merchant Group ID ", accessor: "merchandGroupId", width: "10%", align: "left" },
    ],
    resetTerminalTablecolumns: [
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "IMEI", accessor: "imei", width: "10%", align: "left" },
  
      { Header: "Terminal Id", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    mposUsersTablecolumns: [
      { Header: "User ID", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last Name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile Number", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    merchatnUsersTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      { Header: "user level", accessor: "authorities[0].authority", width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    merchantAllUsersTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "MID", accessor: "groupMid", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      { Header: "user level", accessor: "authorities[0].authority", width: "10%", align: "left" },
    ],
    thirtydaysActiveTablecolumns: [
      { Header: "Username", accessor: "userId", width: "10%", align: "left" },
      { Header: "Tid", accessor: "tid", width: "10%", align: "left" },
      { Header: "First Name", accessor: "fname", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lname", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobNo", width: "10%", align: "left" },
      { Header: "Group mid", accessor: "gmid", width: "10%", align: "left" },
      { Header: "Company Name", accessor: "companyName", width: "10%", align: "left" },
      { Header: "Status", accessor: "st", width: "10%", align: "left" },
      { Header: "Last login date", accessor: row => readableFormatDate2(row.ldt), width: "10%", align: "left" },
    ],
    cashTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      
      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Transaction Id", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "username", accessor: "username", width: "10%", align: "left" },
      { Header: "Transaction Amount", accessor: row => formatNumber(row.txamount), width: "10%", align: "left" },
      { Header: "Tip Amount", accessor: row => formatNumber(row.tipamount), width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
        //  { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Status", accessor: "statusDesc", width: "10%", align: "left" },
      { Header: "Reason", accessor: "reason", width: "10%", align: "left" },
      { Header: "Cash Given", accessor: "cashGiven", width: "10%", align: "left" },
    ],
    cardTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "Surcharge Amount", accessor: row => formatNumber(row.surchangeAmount), width: "10%", align: "left" },
      { Header: "Tip Amount", accessor: row => formatNumber(row.tipAmount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrmode = row.entrmode;
          if (!entrmode) {
            return null;
          } else if (entrmode.startsWith("05")) {
            return "Chip-In";
          } else if (entrmode.startsWith("07")) {
            return "NFC";
          } else if (entrmode.startsWith("02")) {
            return "Mag Stripe";
          } else {
            return "Other"; // Default case for any other conditions
          }
        },
        width: "10%",
        align: "left"
      }],
      cnpTransactionsReportsColumns: [
        { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
  
        { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
        { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
        // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
        { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
        { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
        { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
        { Header: "Surcharge Amount", accessor: row => formatNumber(row.surchangeAmount), width: "10%", align: "left" },
        { Header: "Tip Amount", accessor: row => formatNumber(row.tipAmount), width: "10%", align: "left" },
        { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
        { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
        { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
        { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
        { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
        {
          Header: "Transaction Method",
          accessor: "transactionMethod",
          width: "10%",
          align: "left"
        },      
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
     // { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
     // { Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    dwhTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },

      
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Item No", accessor: "itemNo", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
      { Header: "Card Brand", accessor: row => row.cardBrand, width: "10%", align: "left" },
      { Header: "Bin Country", accessor: row => row.binCountry, width: "10%", align: "left" },
      { Header: "Card Type", accessor: row => row.serviceTypeDesc	, width: "10%", align: "left" },
     // { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
     // { Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    voidTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
      
      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      { Header: "Read Type", accessor: row => row.aid== null || row.aid===""  ? 'MAG' : 'ICC', width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
    //  { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
      //{ Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    refundTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      { Header: "Read Type", accessor: row => row.aid== null || row.aid===""  ? 'MAG' : 'ICC', width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
      //{ Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
      //{ Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    emailTablecolumns: [
      { Header: "Email Id", accessor: "emailid", width: "10%", align: "left" },
      { Header: "Date", accessor: row => readableFormatDate2(row.maildate), width: "10%", align: "left" },
      { Header: "email", accessor: "email", width: "10%", align: "left" },
      { Header: "Status", accessor: "response", width: "10%", align: "left" }
    ],
    smsTablecolumns: [
      { Header: "Mobile Number", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Merchant name / Reference Company Name / Name", accessor: "userDisplayName", width: "10%", align: "left" },
      { Header: "Date", accessor: row => readableFormatDate2(row.otpDate), width: "10%", align: "left" },
      { Header: "SMS", accessor: "sms", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "3" ? "Delivered" : " Not Delivered", width: "10%", align: "left" }
    ],
    onboardingFilesTableColumns: [
      { Header: "MBF File Name", accessor: "mbfFileName", width: "10%", align: "left" },
      { Header: "MBF Total Records", accessor: "mbfTotalRecords", width: "10%", align: "left" },
      { Header: "BRF File Name", accessor: "brfFileName", width: "10%", align: "left" },
      { Header: "BRF Total Records", accessor: "brfTotalRecords", width: "10%", align: "left" },
      { Header: "BSR File Name", accessor: "bsrFileName", width: "10%", align: "left" },
      { Header: "BSR Total Records", accessor: "bsrTotalRecords", width: "10%", align: "left" },
      { Header: "BSR Total Processed Records", accessor: "bsrTotalProcessedRecords", width: "10%", align: "left" },
      { Header: "Total Processed Records", accessor: "totalProcessedRecords", width: "10%", align: "left" }
    ],
    cardSettlementSummaryTableColumns: [
      { Header: "Date", accessor: "date", width: "10%", align: "left" },
      { Header: "MID", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Total Sales", accessor: "salesNo", width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.salesTotal), width: "10%", align: "left" },
      { Header: "Total MSF Charged", accessor: row => formatNumber(row.msfCharged), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: "refundsNo", width: "10%", align: "left" },
      { Header: "Total Refunds Amount", accessor: row => formatNumber(row.refundsTotal), width: "10%", align: "left" },
      { Header: "Net Total", accessor: row => formatNumber(row.netTotal), width: "10%", align: "left" },
    ],
    mdrMasterTableColumns: [
      { Header: "Merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Merchant name", accessor: "merchantName", width: "10%", align: "left" },
      { Header: "CARDHOLDER SURCHARGE", accessor: "cardHoldercharger", width: "10%", align: "left" },
      { Header: "MERCHANT Msf", accessor: "merchantMDr", width: "10%", align: "left" },
      { Header: "Settlement Type", accessor: "settlementType", width: "10%", align: "left" },
      { Header: "Mdr Type", accessor: "mdrType", width: "10%", align: "left" },
      { Header: "Visa Credit", accessor: "visaCredit", width: "10%", align: "left" },
      { Header: "visa Debit", accessor: "visaDebit", width: "10%", align: "left" },
      { Header: "Diners", accessor: "diners", width: "10%", align: "left" },
  
      { Header: "Jcb", accessor: "jcb", width: "10%", align: "left" },
      { Header: "Master Credit", accessor: "masterCredit", width: "10%", align: "left" },
      { Header: "Eftpos", accessor: "eftpos", width: "10%", align: "left" },
      { Header: "Upi", accessor: "upi", width: "10%", align: "left" },
   
      { Header: "Amex", accessor: "amex", width: "10%", align: "left" },
      { Header: "Eftpos(Msf)", accessor: "eftposMsf", width: "10%", align: "left" },
      { Header: "Others(MSF)", accessor: "others", width: "10%", align: "left" },
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],

    mdrMasterNewTableColumns: [
      { Header: "Merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Settlement Type", accessor: "settlementType", width: "10%", align: "left" },
     
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    capkMasterTableColumns: [
      { Header: "DESCRIPTION", accessor: "description", width: "10%", align: "left" },
      { Header: "RID", accessor: "rid", width: "10%", align: "left" },
      { Header: "RID_INDEX", accessor: "ridIndex", width: "10%", align: "left" },
      { Header: "EXPONENT", accessor: "exponent", width: "10%", align: "left" },
      { Header: "MODULUS", accessor: "modulus", width: "10%", align: "left" },
      { Header: "SHA1", accessor: "sha1", width: "10%", align: "left" },
      { Header: "VERSION", accessor: "version", width: "10%", align: "left" },

      { Header: "EXPIRES", accessor: "expires", width: "10%", align: "left" },
  
   
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    
    binMasterTableColumns: [
      { Header: "bin", accessor: "binCode", width: "10%", align: "left" },
      { Header: "bank", accessor: row => row.bankMaster.bankName, width: "10%", align: "left" },
      { Header: "Card type", accessor: row => row.cardTypeMaster.typeName, width: "10%", align: "left" },
      { Header: "Product type", accessor: row => row.productTypeMaster.typeName, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    posTransactionReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row[0].transactionDate), width: "10%", align: "left" },
      { Header: "PAN", accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: "Device Type", accessor:row => row[2].deviceType, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: "TID", accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: "Amount", accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      { Header: "RRN", accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge (%)", accessor:row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge Amount", accessor:row => row[0].cardSurchageAmount, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee (%)", accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee Amount", accessor: row => row[0].msfAmount, width: "10%", align: "left" },
      { Header: "Terminal RRN", accessor: row => row[0].mobileRefNo, width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: "Response Code", accessor: row => row[0].responsecode, width: "10%", align: "left" },
      { Header: "Status", accessor: row => row[0].responsecode === "00" ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reversal Status", accessor: row => row[0].status === '01' ? 'Void Transaction' : '', width: "10%", align: "left" },
      { Header: "Refund Status", accessor: row => row[0].status === '02' ? 'Refund Transaction' : '', width: "10%", align: "left" },
      { Header: "Auth Id", accessor: row => row[0].authid, width: "10%", align: "left" },
      // { Header: "Invoice No", accessor: row => row.invoiceNo, width: "10%", align: "left" },
      { Header: "Application Name", accessor: row => row[0].appName, width: "10%", align: "left" },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrmode = row[0].entrmode;
          if (entrmode.startsWith("05")) {
            return "Chip-In";
          } else if (entrmode.startsWith("07")) {
            return "NFC";
          } else if (entrmode.startsWith("02")) {
            return "Mag Stripe";
          } else {
            return "Unknown"; // Default case if no match
          }
        },
        width: "10%",
        align: "left"
      },
    ],
    settlementReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row[0].transactionDate), width: "10%", align: "left" },
      { Header: "PAN", accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: "RRN", accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: "TID", accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: "Amount", accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      // { Header: "Issuer Name", accessor: row => row[0].issuerName, width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: "Settlement Account Number", accessor: row => row[1].accountNo, width: "10%", align: "left" },
     
      { Header: "Card Holder Surcharge %", accessor: row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      { Header: "Card Holder Surcharge Amount", accessor: row => formatNumber(row[0].cardSurchageAmount), width: "10%", align: "left" },
      { Header: "Merchant service fee %", accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      { Header: "Merchat service fee amount", accessor: row => formatNumber(row[0].msfAmount), width: "10%", align: "left" },
      { Header: "Merchant settlement amount", accessor: row => formatNumber(row[0].merchantSettlementAmount), width: "10%", align: "left" },
      //{ Header: "Device type", accessor: row => row[1].posMachineType, width: "10%", align: "left" },
      { Header: "Application name", accessor: row => row[0].appName, width: "10%", align: "left" },
      // { Header: "Branch Name", accessor: row => row[1].bankerBranchName, width: "10%", align: "left" },
      { Header: "Status", accessor: row => row[0].responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reversal Status", accessor: row => row[0].status === "01" ? 'Void Transaction' : '', width: "10%", align: "left" },
      { Header: "Auth Id", accessor: row => row[0].authid, width: "10%", align: "left" },
      { Header: "Invoice No", accessor: row => row[0].invoiceNo, width: "10%", align: "left" },
    ],

    
    netSettlementReportsColumns: [
      { Header: "Date", accessor: row => row.settlementDate, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.totalSaleAmount), width: "10%", align: "left" },
      { Header: "Msf Charged", accessor: row => formatNumber(row.totalMsfAmount), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
      { Header: "Lodgement Reference", accessor: row => row.lodgementRefNumber, width: "10%", align: "left" },
      { Header: "Settlement Amount", accessor: row => formatNumber(row.merchantSettlementAmount), width: "10%", align: "left" },
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    monthlyNetSettlementReportsColumns: [
      { Header: "Date", accessor: row => row.yearMonth, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Registered Business Name", accessor: row => row.companyName, width: "10%", align: "left" },
      { Header: "Abn", accessor: row => row.abn, width: "10%", align: "left" },
      { Header: "Email", accessor: row => row.email, width: "10%", align: "left" },
      { Header: "Address", accessor: row => row.address, width: "10%", align: "left" },

      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.totalSaleAmount), width: "10%", align: "left" },
      { Header: "Msf Charged", accessor: row => formatNumber(row.totalMsfAmount), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
      { Header: "Total Settlement Amount", accessor: row => formatNumber(row.totalMerchantSettlementAmount), width: "10%", align: "left" },
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    grossSettlementReportsColumns: [
     { Header: "Date", accessor: row => row.yearMonth, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Registered Business Name", accessor: row => row.companyName, width: "10%", align: "left" },
      { Header: "Abn", accessor: row => row.abn, width: "10%", align: "left" },
      { Header: "Email", accessor: row => row.email, width: "10%", align: "left" },
      { Header: "Address", accessor: row => row.address, width: "10%", align: "left" },


      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => row.totalSaleAmount, width: "10%", align: "left" },
    //  { Header: "Total Refunds", accessor: row => row.totalRefundAmount, width: "10%", align: "left" },
      { Header: "Settlement Amount", accessor: row => row.totalMerchantSettlementAmount, width: "10%", align: "left" },
     // { Header: "Msf", accessor: row => row.merchantMDr, width: "10%", align: "left" },
      { Header: "Total IC Amount", accessor: row => row.totalIcAmt, width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
  
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    ruleTableColumns: [
      { Header: "Rule Id", accessor: "ruleID", width: "10%", align: "left" },
      { Header: "Rule", accessor: rule => 'IF '+rule.conditionField.toUpperCase()+' IS '+ (rule.conditionOperator.toUpperCase() === 'BETWEEN' ? ' FROM '+rule.conditionFromValue+' TO '+rule.conditionToValue  : rule.conditionFromValue)
          +' THEN ACQUIRER IS '+rule.acquirer.name, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    merchantStatementColumns: [
      { Header: "MID", accessor: "mid", width: "10%", align: "left" },
      { Header: "Statement Month", accessor: row => monthConverter(row.statementDate), width: "10%", align: "left" },
      { Header: "Generated on", accessor: row => readableFormatDate(row.createdAt), width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],

    DeFileReleaseScreenColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs) , width: "10%", align: "left" },

      { Header: "File Name ", accessor: "fileName", width: "10%", align: "left" ,  Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ),},
      { Header: "DWH File Name", accessor: "dwhFileName", width: "10%", align: "left" },
      { Header: "Settlement Date (YY-MM-DD)", accessor: "settlementDate", width: "10%", align: "left" },
      { Header: "Total Records", accessor: "totalRecords", width: "10%", align: "left" },

      { Header: "File Value", accessor: "deFileValue", width: "10%", align: "left" },
        { Header: "IS Send Fiserv", accessor: "isPushedFiserv", width: "10%", align: "left" },
        { 
          Header: "Send Timestamp", 
          accessor: row => {
            const timestamp = row.fiservTimpStamp;
            return timestamp ? readableFormatDate2(timestamp) : null; // Change null to "" if you want an empty string
          }, 
          width: "10%", 
          align: "left" 
        },
        
      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ],

   DwhFileProccessColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs), width: "10%", align: "left" },

      { Header: "File Name ", accessor: "fileName", width: "10%", align: "left",  Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ), },
      {
        Header: "Is Processed",
        accessor: "flag",
        width: "10%",
        align: "left",
        Cell: ({ value }) => (value ? "Y" : "N") // Custom rendering logic
      }
,      

      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ],
    DeReplyColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs), width: "10%", align: "left" },

      { Header: "DE File", accessor: "deFileName", width: "10%", align: "left" },
      { Header: "De Reply File ", accessor: "fileName", width: "10%", align: "left", Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ), },
      { Header: "Total Records", accessor: "totalRecords", width: "10%", align: "left" },
   
      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ]
  };
}
